import type { SectionListItemDto } from '../api/generated'

export const sectionImages: Record<string, string> = {
  Автомобили: '/images/sections/production/6.jpg',
  Аксессуары: '/images/sections/production/7.jpg',
  'Водный транспорт и авиация': '/images/sections/production/8.jpg',
  'Для бизнеса': '/images/sections/production/9.jpg',
  'Для дома и дачи': '/images/sections/production/10.jpg',
  'Для фотосессий': '/images/sections/production/11.jpg',
  Животные: '/images/sections/production/12.jpg',
  'Здоровье и медицина': '/images/sections/production/13.jpg',
  Инструменты: '/images/sections/production/14.jpg',
  Люди: '/images/sections/production/15.jpg',
  Недвижимость: '/images/sections/production/16.jpg',
  Одежда: '/images/sections/production/17.jpg',
  Путешествия: '/images/sections/production/18.jpg',
  Развлечения: '/images/sections/production/19.jpg',
  'Спец. техника': '/images/sections/production/20.jpg',
  Спорт: '/images/sections/production/21.jpg',
  Творчество: '/images/sections/production/22.jpg',
  Техника: '/images/sections/production/23.jpg',
  'Товары для детей': '/images/sections/production/24.jpg',
  'Цифровая техника': '/images/sections/production/25.jpg',
  Другое: '/images/sections/production/26.jpg',
}

export const getSectionImage = (section: SectionListItemDto) =>
  section.imageUrl || sectionImages[section.name || ''] || '/images/sections/production/25.jpg'
